export enum CatalogItemType {
  CROSSSELLGROUP = 'crossSellGroup',
  PRODUCT = 'product',
  PRODUCTGROUP = 'productGroup',
  MODIFIER = 'modifier',
  MODIFIERGROUP = 'modifierGroup',
  COMPONENTGROUP = 'componentGroup',
  COMPOSITE = 'composite',
  PRODUCT_GROUP = 'productGroup',
  SALES_GROUP = 'salesGroup',
  MODIFIER_GROUP = 'modifierGroup',
  COMPONENT_GROUP = 'componentGroup',
  INSTRUCTION = 'instruction',
  UPSELLGROUP = 'upsellGroup',
  TAG = 'tag',
  RULE = 'rule',
}
